angular.
module("dx.webapp.api").
factory("dxApiV1Invites", function apiV1InvitesService(
	$http
) {
	"use strict";

	var baseUrl = "/api/v1/invites/";

	function forceAccept(id) {
		var url = baseUrl + id + "/forceaccept";

		return $http.post(url);
	}

	return {
		forceAccept: {
			post: forceAccept,
		},
	};
});
